import React from 'react';

export type LoaderSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type LoaderVariant = 'primary' | 'white' | 'wine';

interface LoaderProps {
  size?: LoaderSize;
  variant?: LoaderVariant;
  className?: string;
  message?: string;
  fullPage?: boolean;
}

const sizeClasses: Record<LoaderSize, string> = {
  xs: 'h-4 w-4',
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-10 w-10',
  xl: 'h-32 w-32'
};

const variantClasses: Record<LoaderVariant, string> = {
  primary: 'border-[#047857]',
  white: 'border-white border-t-transparent',
  wine: 'border-wine-100'
};

export const Loader: React.FC<LoaderProps> = ({
  size = 'md',
  variant = 'primary',
  className = '',
  message,
  fullPage = false
}) => {
  const spinnerClasses = `inline-block animate-spin rounded-full border-b-2 ${sizeClasses[size]} ${variantClasses[variant]} ${className}`;

  if (fullPage) {
    return (
      <div className="min-h-full h-full w-full flex items-center justify-center">
        <div className="text-center">
          <div className={spinnerClasses}></div>
          {message && <p className="mt-4 text-sm text-gray-500">{message}</p>}
        </div>
      </div>
    );
  }

  if (message) {
    return (
      <div className="text-center py-20">
        <div className={spinnerClasses}></div>
        <p className="mt-4 text-sm text-gray-500">{message}</p>
      </div>
    );
  }

  return <div className={spinnerClasses}></div>;
};

export default Loader;

